var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"button btn btn-success copy-invoice-button",on:{"click":function($event){$event.preventDefault();return _vm.onClick.apply(null, arguments)}}},[_c('span',{staticClass:"material-symbols-outlined copy-icon"},[_vm._v("content_copy")]),_vm._v("\n  Copy\n")])
}
var staticRenderFns = []

export { render, staticRenderFns }